import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";
import { MonthlyTradingReportFilter } from "../types";

export const getMonthlyReport = (
  user: User,
  filter: MonthlyTradingReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getmonthlytradingreport",
    params: {
      userid: user.userId,
      numofmonths: filter.numofmonths,
    },
  });
};

export default getMonthlyReport;
